import React, { useState, useRef, useContext } from "react";
import useSiteData from '../../useSiteData'
import Menu from "./Menu";
import Icon from "../atoms/Icon";
import Submenu from "./Submenu";
import NavLink from "../molecules/NavLink";
import SocialMediaList from "./SocialMediaList";
import { Link } from "../Router";
import * as contentTypes from "../../api/contentTypes";
import { isCurrentPathActive, isSubmenuActive } from "../../util/navigation";
import LinkButton from "../atoms/LinkButton";
import { HeaderThemeContext, headerThemes } from "../../context";

const wrapNavigationGroupInSubmenu = navigationGroup => ({
    title: "",
    navigationGroups: [navigationGroup]
});

export default ({ isActive, onCloseMenu }) => {
    const { submenus, mobileNavigationBackButtonText = "Back" } = useSiteData().navigationPrimary;
    const [activeSubmenu, setActiveSubmenu] = useState(null);

    const isSelected = useRef(isActive);

    // Means last render was open, now is closed, reset submenu!
    if (isSelected.current && !isActive) {
        setActiveSubmenu(null);
    }

    isSelected.current = isActive;
    const submenuLast = submenus[submenus.length - 1];

    const { theme } = useContext(HeaderThemeContext);

    if (theme === headerThemes.INVISIBLE) return null;

    return (
        <Menu isActive={ isActive }>
            <div className="o-menu__wrapper">
                <div className="o-navigation-primary">
                    { submenus
                    .slice(0, submenus.length - 1)
                    .filter(menu => menu.navigationGroups || menu.page)
                    .map((submenu, index) => {
                            const directLink = (!submenu.navigationGroups && submenu.page) ?
                                submenu.page.slug : undefined;

                            return (
                                <LinkButton
                                    className={
                                        "o-navigation-primary__btn m-btn-extended m-btn-extended--flex a-btn a-btn--transparent" +
                                        (isSubmenuActive(submenu) ? " o-navigation-primary__btn--selected" : "")
                                    }
                                    key={ index }
                                    onClick={ !directLink ? () => setActiveSubmenu(submenu) : onCloseMenu }
                                    url={ directLink }
                                >
                                    <span className="m-btn-extended__text">{ submenu.title }</span>
                                    { !directLink &&
                                    <Icon
                                        className="m-btn-extended__icon a-icon a-icon--xs a-icon--red"
                                        iconName="icon-chevron-right"
                                    />
                                    }
                                </LinkButton>
                            );
                        }
                    ) }

                    { submenuLast.navigationGroups

                    .filter(({ pages }) => pages.length > 0 && pages.some(page => !page.locales))
                    .map((navigationGroup, index) => {
                            const blogPage = navigationGroup.pages[0];

                            if (blogPage.contentType !== contentTypes.PAGE_BLOG_ARCHIVE) {
                                return (
                                    <button
                                        className="o-navigation-primary__btn m-btn-extended m-btn-extended--flex a-btn a-btn--transparent"
                                        key={ index }
                                        onClick={ () => setActiveSubmenu(wrapNavigationGroupInSubmenu(navigationGroup)) }
                                    >
                                        <span className="m-btn-extended__text">{ navigationGroup.label }</span>
                                        <Icon
                                            className="m-btn-extended__icon a-icon a-icon--xs a-icon--red"
                                            iconName="icon-chevron-right"
                                        />
                                    </button>
                                )
                            }

                            const isSelected = isCurrentPathActive(blogPage.slug, { ignoreQueryParams: true });
                            
                            return (
                                <Link
                                    className={
                                        "o-navigation-primary__btn" +
                                        (isSelected ? " o-navigation-primary__btn--selected" : "") +
                                        " a-btn a-btn--transparent"
                                    }
                                    to={ '/' + blogPage.slug }
                                    key={ index }
                                    onClick={ onCloseMenu }
                                >
                                    { blogPage.navigationTitle }
                                </Link>
                            );
                        }
                    ) }

                    <NavLink/>
                    <div className="o-menu__row">
                        <SocialMediaList isRound/>
                    </div>
                </div>
                <Menu isActive={ !!activeSubmenu } sub>
                    <button
                        className="o-submenu__btn m-btn-extended a-btn a-btn--transparent"
                        onClick={ () => setActiveSubmenu(null) }
                        tabIndex={ !activeSubmenu ? -1 : null }
                    >
                        <Icon className="m-btn-extended__icon a-icon a-icon--xs" iconName="icon-chevron-left"/>
                        <span className="m-btn-extended__text">{ mobileNavigationBackButtonText }</span>
                    </button>
                    { activeSubmenu &&
                    <Submenu { ...activeSubmenu } onLinkClick={ onCloseMenu }/>
                    }
                    <NavLink/>
                    <div className="o-menu__row">
                        <SocialMediaList isRound/>
                    </div>
                </Menu>
            </div>
        </Menu>
    );
}
